import React from "react";

import { PlusOutlined } from "@ant-design/icons";
import "./COABuilderAddSection.css";

export default function COABuilderAddSection({ handleAddSection }) {
  return (
    <div className="COABuilderAddSection__Container">
      <div className="COABuilderAddSection__Line" />
      <div className="COABuilder__AddSectionButton" onClick={handleAddSection}>
        <PlusOutlined className="COABuilder__AddIcon" aria-hidden />
        <span>Add Section</span>
      </div>
      <div className="COABuilderAddSection__Line" />
    </div>
  );
}
